import { adminQueryKeys } from "./admin";
import { athleteQueryKeys } from "./athlete";
import { campPortalQueryKeys } from "./camp";
import { clubPortalQueryKeys } from "./club-portal";
import { clubsQueryKeys } from "./clubs";
import { coachQueryKeys } from "./coach";
import { commerceQueryKeys } from "./commerce";
import { coreQueryKeys } from "./core";
import { financeQueryKeys } from "./finance";
import { locationQueryKeys } from "./locations";
import { newsQueryKeys } from "./news";
import { outboxQueryKeys } from "./outbox";
import { reportingQueryKeys } from "./reporting";
import { venuePortalQueryKeys } from "./venue";

export const queryKeys = {
	...coreQueryKeys,
	...newsQueryKeys,
	...locationQueryKeys,
	...clubsQueryKeys,
	...clubPortalQueryKeys,
	...financeQueryKeys,
	...athleteQueryKeys,
	...adminQueryKeys,
	...coachQueryKeys,
	...reportingQueryKeys,
	...commerceQueryKeys,
	...outboxQueryKeys,
	...venuePortalQueryKeys,
	...campPortalQueryKeys,
} as const;
